import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/public/logo.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/new/AboutNivaran/AboutNivaran.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/new/DonationBlock/DonationBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/new/HeroSection/HeroSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/new/HomeFloodAppeal/HomeFloodAppeal.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/new/InsightsAndInspiration/InsightsAndInspiraton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/new/NewsletterSubscribe/NewsletterSubscribe.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/new/nivaranHeader/NivaranHeader.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/new/ProjectSanjeevani/ProjectSanjeevani.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/new/WhatsAppButton/WhatsAppButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/nivaran/common/footer/FooterHollow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/nivaran/common/WeatherAdvisory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SetCookie"] */ "/app/src/components/nivaran/main/utils/SetCookie.tsx");
